import React from "react";

function PowerfulTradingEngine() {
  return (
    <>
      <div className="about-style-four-area default-padding-bottom">
        <div className="container">
          <div className="row">
            <div className="col-xl-7">
              <div className="about-style-four-info">
                <h4 className="sub-title">About Xeer</h4>
                <h2 className="title">Unleashing Power of P2P Trading</h2>
                <p>
                  Xeer Technology specializes in developing a peer-to-peer (P2P)
                  crypto exchange platform, tailored to meet the evolving needs
                  of the crypto marketplace.
                </p>
                <p>
                  Our P2P exchanges empower users to trade cryptocurrencies
                  directly with one another without the need for intermediaries,
                  ensuring greater privacy, lower transaction fees, and enhanced
                  control over assets.
                </p>
              </div>
            </div>
            <div className="col-xl-4 offset-xl-1">
              <div className="about-four-right-info">
                <div className="thumb">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/about/4.jpg"
                    alt="Image Not Found"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PowerfulTradingEngine;
